// extracted by mini-css-extract-plugin
export default {"heading":"RegionSchoolsAttendancePage_heading__bEEtG"};